import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LoginForm, LoginFormData } from '../../components/auth/LoginForm';
import { useAuth } from '../../components/auth/AuthContext';
export function VendorLogin() {
  const navigate = useNavigate();
  const {
    login
  } = useAuth();
  const handleLogin = (data: LoginFormData) => {
    // In a real application, this would call an API endpoint
    console.log('Vendor login data:', data);
    // Simulate successful login without authentication
    const userData = {
      type: 'vendor',
      email: data.email,
      name: 'Vendor User'
    };
    localStorage.setItem('user', JSON.stringify(userData));
    login(userData);
    // Directly navigate to vendor portal without authentication
    navigate('/vendor');
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-650">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-651">
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-652">
          Vendor Login
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600" data-id="element-653">
          Or{' '}
          <Link to="/auth/vendor-register" className="font-medium text-primary hover:text-primary/80" data-id="element-654">
            register your company
          </Link>
        </p>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-655">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" data-id="element-656">
          <LoginForm userType="vendor" onSubmit={handleLogin} data-id="element-657" />
          <div className="mt-6" data-id="element-658">
            <div className="relative" data-id="element-659">
              <div className="absolute inset-0 flex items-center" data-id="element-660">
                <div className="w-full border-t border-gray-300" data-id="element-661" />
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-662">
                <span className="px-2 bg-white text-gray-500" data-id="element-663">
                  Or continue with
                </span>
              </div>
            </div>
            <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-664">
              <div data-id="element-665">
                <a href="#" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-666">
                  <span className="sr-only" data-id="element-667">Sign in with Google</span>
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-668">
                    <path d="M12.545 10.239v3.821h5.445c-.712 2.315-2.647 3.972-5.445 3.972a6.033 6.033 0 110-12.064 5.963 5.963 0 014.123 1.608l2.685-2.688A9.95 9.95 0 0012.545 2.001a10.003 10.003 0 000 20.005c5.552 0 9.455-4.009 9.455-9.648a9.032 9.032 0 00-.16-1.675h-9.295z" data-id="element-669" />
                  </svg>
                </a>
              </div>
              <div data-id="element-670">
                <a href="#" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-671">
                  <span className="sr-only" data-id="element-672">Sign in with LinkedIn</span>
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-673">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-674" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div className="mt-6 text-center" data-id="element-675">
            <Link to="/auth/customer-login" className="font-medium text-primary hover:text-primary/80" data-id="element-676">
              Login as a customer instead
            </Link>
          </div>
        </div>
      </div>
    </div>;
}